import React from "react";

export const nothingLeft = {
  title: "Nothing Left",
  date: "2016",
  about: (
    <>
      <p>
        Through the subject of the European witch hunts, these works explore
        precarity and loss.
      </p>
      <p>
        While the mention of witch hunts usually conjures images of Dark Age
        peasants wielding pitchforks and torches in superstitious frenzy, the
        historical reality is that the witch hunts took place after the end of
        the Middle Ages and during the early Modern era. This femicide on a
        massive scale was in fact a tool of the ascendant capitalist order,
        serving to suppress resistance against the privatisation of the commons,
        while also restricting and devaluing women’s freedom and labour. The
        degradation of women’s status during this time is something western
        society has yet to fully recover from.
      </p>
      <p>
        The paintings of Nothing Left embody a personal exploration of this
        subject, in which historical trauma and personal trauma and loss feed
        into each other while both seeming to repeat in an endless loop.
      </p>
    </>
  ),
  gallery: [
    {
      img: "nothingLeft1.jpg",
      thumb: "nothingLeftThumb1.jpg",
      size: "58 × 70 cm",
      material: "Acrylic paint, latex paint, glue, newspaper.",
      date: "2016",
      dimensions: {
        width: "1764",
        height: "2178",
      },
    },
    {
      img: "nothingLeft2.jpg",
      thumb: "nothingLeftThumb2.jpg",
      size: "35 × 59 cm",
      material: "Acrylic paint, latex paint, glue, newspaper.",
      date: "2016",
      dimensions: {
        width: "1982",
        height: "3376",
      },
    },
    {
      img: "nothingLeft3.jpg",
      thumb: "nothingLeftThumb3.jpg",
      size: "43 × 33 cm",
      material: "Latex paint, charcoal, glue, tissue, found paper.",
      date: "2016",
      dimensions: {
        width: "3252",
        height: "2526",
      },
    },
    {
      img: "nothingLeft4.jpg",
      thumb: "nothingLeftThumb4.jpg",
      size: "30 × 128 cm",
      material:
        "Acrylic paint, latex paint, charcoal, glue, cardboard, newspaper.",
      date: "2016",
      dimensions: {
        width: "820",
        height: "3468",
      },
    },
    {
      img: "nothingLeft5.jpg",
      thumb: "nothingLeftThumb5.jpg",
      size: "113 × 184 cm",
      material: "Acrylic paint, latex paint, glue, found paper.",
      date: "2016",
      dimensions: {
        width: "2152",
        height: "3336",
      },
    },
    {
      img: "nothingLeft6.jpg",
      thumb: "nothingLeftThumb6.jpg",
      size: "95 × 81.5 cm",
      material: "Acrylic paint, latex paint, charcoal, glue, newspaper.",
      date: "2016",
      dimensions: {
        width: "2763",
        height: "2358",
      },
    },
    {
      img: "nothingLeft7.jpg",
      thumb: "nothingLeftThumb7.jpg",
      size: "23 × 34 cm",
      material: "Acrylic paint, latex paint, copy paper.",
      date: "2016",
      dimensions: {
        width: "2272",
        height: "3244",
      },
    },
  ],
};
